import React from 'react';
import { splitBodyParagraphs } from '../../utils/cmsContentLoader';

export default function GuideBodyText({ text, className = 'guide-detail__body' }) {
	const paragraphs = splitBodyParagraphs(text);
	if (!paragraphs.length) return null;
	return (
		<div className={className}>
			{paragraphs.map((paragraph, i) => (
				<p key={i}>{paragraph}</p>
			))}
		</div>
	);
}
